<template>
    <b-dropdown
        aria-role="list"
        class="language-dropdown"
        :mobile-modal="false"
        :disabled="!hasTranslations"
        position="is-bottom-left">
        <button class="button is-primary is-outlined" slot="trigger" :class="{ disabled: !hasTranslations }">
            <span class="icon is-small hideOnCollapse">
                <font-awesome-icon :icon="['fas', 'globe']" />
            </span>
            <span>
                {{ value }}
            </span>
            <span class="icon is-small hideOnCollapse" v-if="hasTranslations">
                <font-awesome-icon :icon="['fas', 'angle-down']" />
            </span>
        </button>

        <!-- Default language-->
        <b-dropdown-item has-link aria-role="listitem">
            <a href="#" @click.prevent="setLibraryLanguage(defaultLanguage)">
                {{ defaultLanguage.id.toUpperCase() }}
                -
                {{ defaultLanguage.isoLanguageName }}
            </a>
        </b-dropdown-item>
        <!--Additional languages-->
        <b-dropdown-item has-link v-for="language in languages" :key="language.id" aria-role="listitem">
            <a href="#" @click.prevent="setLibraryLanguage(language)">
                {{ language.id.toUpperCase() }} -
                {{ language.isoLanguageName }}
            </a>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faGlobe, faAngleDown } from '@fortawesome/free-solid-svg-icons';

library.add(faGlobe);
library.add(faAngleDown);

export default {
    name: 'LibraryLanguageSelect',
    components: {
        FontAwesomeIcon,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        defaultLanguage: {
            type: Object,
        },
        languages: { type: Array },
        value: { type: String },
    },
    data: function () {
        return {};
    },
    watch: {
        defaultLanguage() {
            this.handleActiveLibraryLang();
        },
    },
    created() {
        this.handleActiveLibraryLang();
    },
    computed: {
        hasTranslations() {
            return this.languages?.length > 0;
        },
    },
    methods: {
        handleActiveLibraryLang() {
            var value = sessionStorage.getItem(`activeLibraryLang.${this.id}`);
            if (!value) {
                //check if a value is set, if not use the default library of the library and save
                this.setLibraryLanguage(this.defaultLanguage);
            } else {
                this.$emit('input', value);
            }
        },
        setLibraryLanguage(language) {
            sessionStorage.setItem(`activeLibraryLang.${this.id}`, language.id);
            this.$emit('input', language.id);
        },
    },
};
</script>
